
// This file is used for SSR prerendering
// It contains the same data as blog-posts.ts but in a format that can be imported by Node.js directly
import { blogContents } from './blog-content.js';

export const blogPosts = [
  {
    id: '6',
    title: "AI-Powered Self-Healing Automated Test: The Future of Testing",
    slug: 'ai-powered-self-healing-automated-test',
    date: '2025-05-20',
    thumbnail: '/lovable-uploads/517c0751-c675-425d-9b3e-082b97274bbf.png',
    summary: 'Discover how AI-powered self-healing test automation reduces maintenance time by 70%, eliminates false negatives, and enables teams to focus on meaningful test development rather than constant upkeep.',
    content: blogContents['ai-powered-self-healing-automated-test']
  },
  {
    id: '5',
    title: "The IT Manager's Handbook to Outsourcing Website Development",
    slug: 'it-managers-handbook-outsourcing-website-development',
    date: '2025-05-14',
    thumbnail: '/lovable-uploads/a1a04d1f-80af-42ef-9686-0591082901c0.png',
    summary: 'A comprehensive guide for IT managers on how to successfully outsource website development projects, including vendor selection, quality assurance, and ensuring project success.',
    content: blogContents['it-managers-handbook-outsourcing-website-development']
  },
  {
    id: '4',
    title: 'Get Professional AI-assisted QA Testing Service for Your Website',
    slug: 'professional-ai-assisted-qa-testing-service',
    date: '2025-05-10',
    thumbnail: '/lovable-uploads/d357e91b-aa7d-4948-8781-12c666e41ac0.png',
    summary: 'Learn how AI-assisted QA testing services can help improve your website quality, reduce testing time, and enhance user experience while ensuring comprehensive bug detection.',
    content: blogContents['professional-ai-assisted-qa-testing-service']
  }
];
